var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.401 17.283",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.609 -2.525)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.101,
    cy: 1.101,
    r: 1.101,
    transform: "translate(10.237 14.859)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.125,12.774a.724.724,0,0,0,.761-.676V6.721a.767.767,0,0,0-1.523,0V12.1A.725.725,0,0,0,10.125,12.774Z",
    transform: "translate(1.21 1.393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.76,16.429,13.341,3.673a2.314,2.314,0,0,0-4,.006l-7.4,12.712a2.221,2.221,0,0,0-.05,2.262,2.307,2.307,0,0,0,2.049,1.155H18.625A2.367,2.367,0,0,0,20.662,18.7,2.316,2.316,0,0,0,20.76,16.429Zm-1.081,1.659a1.206,1.206,0,0,1-1.054.564H3.943A1.168,1.168,0,0,1,2.9,18.083a1.072,1.072,0,0,1,.039-1.106l7.394-12.71a1.159,1.159,0,0,1,2.012-.007l7.388,12.7A1.167,1.167,0,0,1,19.679,18.088Z",
    transform: "translate(0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.7fcd4468.svg";
export { ForwardRef as ReactComponent };